/* ==========================================================================
   Aronia ORIGINAL — Header behaviour (Krown "Local")
   Vanilla JS, no dependencies. Loaded with `defer`.
   Handles: nav dropdowns (hover + keyboard/touch), "Alle Produkte" mega-menu,
   optional sticky shrink, and the mobile drawer.
   Safe to run once; guards against double-init (Krown re-renders sections in
   the Theme Editor — we listen for shopify:section:load).
   ========================================================================== */
(function () {
  function initHeader(root) {
    if (!root || root.__aoInit) return;
    root.__aoInit = true;

    /* ---- Mega-menu ("Alle Produkte") ---- */
    var megaBtn = root.querySelector('[data-ao-mega-toggle]');
    var mega = root.querySelector('[data-ao-mega]');
    if (megaBtn && mega) {
      var scrim = null;
      var openMega = function () {
        mega.classList.add('is-open');
        megaBtn.setAttribute('aria-expanded', 'true');
        scrim = document.createElement('div');
        scrim.className = 'ao-mega__scrim';
        scrim.addEventListener('click', closeMega);
        mega.parentNode.appendChild(scrim);
      };
      var closeMega = function () {
        mega.classList.remove('is-open');
        megaBtn.setAttribute('aria-expanded', 'false');
        if (scrim) { scrim.remove(); scrim = null; }
      };
      megaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        mega.classList.contains('is-open') ? closeMega() : openMega();
      });
      root.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
    }

    /* ---- Nav dropdowns: hover is CSS; add click/touch + keyboard ---- */
    root.querySelectorAll('.ao-nav__item--has-menu').forEach(function (item) {
      var link = item.querySelector('.ao-nav__link');
      if (!link) return;
      /* Der Zustand sitzt seit 04.08.2026 am LINK, nicht mehr am Wrapper-div —
         ein div ohne Rolle darf aria-expanded nicht tragen. */
      link.addEventListener('click', function (e) {
        // Only intercept when it has a submenu and modifier keys aren't used
        if (window.matchMedia('(hover: none)').matches) {
          var expanded = link.getAttribute('aria-expanded') === 'true';
          if (!expanded) { e.preventDefault(); link.setAttribute('aria-expanded', 'true'); }
        }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); link.setAttribute('aria-expanded', 'true');
          var first = item.querySelector('.ao-dropdown a'); if (first) first.focus(); }
        if (e.key === 'Escape') { link.setAttribute('aria-expanded', 'false'); }
      });
      /* Escape aus dem geoeffneten Menue heraus: schliessen und zum Ausloeser zurueck,
         sonst haengt der Fokus in einem unsichtbaren Menue. */
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        root.querySelectorAll('.ao-nav__link[aria-expanded="true"]').forEach(function (l) {
          l.setAttribute('aria-expanded', 'false');
        });
      }
    });

    /* ---- Optional sticky shrink ---- */
    if (root.classList.contains('ao-header--sticky')) {
      var onScroll = function () { root.classList.toggle('ao-header--stuck', window.scrollY > 40); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---- Mobile drawer ---- */
    var burger = root.querySelector('[data-ao-burger]');
    var drawer = root.querySelector('[data-ao-drawer]');
    var overlay = root.querySelector('[data-ao-drawer-overlay]');
    if (burger && drawer) {
      var toggle = function (open) {
        drawer.classList.toggle('is-open', open);
        if (overlay) overlay.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', function () { toggle(!drawer.classList.contains('is-open')); });
      if (overlay) overlay.addEventListener('click', function () { toggle(false); });
    }
  }

  function boot() { document.querySelectorAll('[data-ao-header]').forEach(initHeader); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Re-init when the section is reloaded in the Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ao-header]');
    if (el) { el.__aoInit = false; initHeader(el); }
  });
})();
